import React from 'react'
import {Form, Input, DatePicker} from "antd";
import config from "../../../config";

const ShippingOrderFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'customerName'}
                label={'Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'dispatchNo'}
                label={'İrsaliye No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'date'}
                label={'Sevk Tarihi'}
                initialValue={''}
            >
                <DatePicker format={config.userDateFormat}/>
            </Form.Item>
        </React.Fragment>
    )
}

export default ShippingOrderFilter